import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { OidcProvider } from '@/auth/OidcProvider'
import { ThemeProvider } from '@/context/ThemeContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { ToastProvider } from '@/context/ToastContext'
import { AppErrorBoundary } from '@/app/AppErrorBoundary'
import '@/shared/styles/global.css'
import { routes } from '@/app/routes'


const router = createBrowserRouter(routes)

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    {/* Outermost (above ThemeProvider): global.css puts the CSS vars on :root
        and the theme attr comes from the index.html inline script, so the
        fallback renders correctly even when a provider itself throws. */}
    <AppErrorBoundary>
      <ThemeProvider>
        <SidebarProvider>
          <OidcProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </OidcProvider>
        </SidebarProvider>
      </ThemeProvider>
    </AppErrorBoundary>
  </StrictMode>,
)
